module.exports = {
  Character: {
    PluginName: "Karakter",
  },
};
